import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import routes from '../../config/routes';
import { hasPermissions } from '../../helpers';
import { AppPermissions } from '../../types';
import {
  isAuthenticatedSelector,
  userPermissionsDataSelector,
  canUserSeeSynchroSelector,
  canUserSeeParametricStoresSelector,
} from '../../state';
import NavigateWithReturnUrl from './NavigateWithReturnUrl';

interface PrivateRouteProps {
  component: FunctionComponent;
  permissions?: AppPermissions[];
}

const PrivateRoute = ({
  component: Component,
  permissions: routePermissions,
}: PrivateRouteProps) => {
  const { forbiddenComponent: Forbidden } = routes;

  const isAuthenticated = useSelector(isAuthenticatedSelector);

  const permissionsData = useSelector(userPermissionsDataSelector);
  const userPermissions = permissionsData.map(i => i.permission);

  const canSeeSynchro = useSelector(canUserSeeSynchroSelector);
  const canSeeParametricStores = useSelector(canUserSeeParametricStoresSelector);

  if (!isAuthenticated) return <NavigateWithReturnUrl path={routes.signinRoute.path} />;

  const isAuthorized = !routePermissions || hasPermissions(userPermissions, routePermissions);

  if (!isAuthorized) return <Forbidden />;

  if (routePermissions?.includes(AppPermissions.SYNCHRO_4_ME) && !canSeeSynchro) {
    return <Forbidden />;
  }

  // Tener el permiso no alcanza: el pais tiene que estar habilitado en el parametro, igual que
  // en synchro. Sin esto se entra escribiendo la direccion a mano.
  if (routePermissions?.includes(AppPermissions.PARAMETRIC_STORES) && !canSeeParametricStores) {
    return <Forbidden />;
  }

  return <Component />;
};

export default PrivateRoute;
